import { QueryResult, useQuery } from '@apollo/client'
import { ChangeEvent, ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

import { Select } from 'components/v2/Select'
import { GET_COUNTRIES } from 'features/Cities/queries-legacy'
import { GTCountriesOutput, GTCountry } from 'gql/types.generated'
import { ISelectCountriesProps } from './types'

const messages = defineMessages({
  selectCountryCode: {
    id: 'cities.new.form.countryCode.select',
    defaultMessage: 'Choose a country'
  }
})

export const useCountries = (): QueryResult<{ countries: GTCountriesOutput }> => {
  return useQuery<{ countries: GTCountriesOutput }>(GET_COUNTRIES, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  })
}

export const useCountry = (countryCode: string): GTCountry | undefined => {
  const { data } = useCountries()
  const countries = data?.countries?.items || []
  return countries.find((country) => country.code === countryCode)
}

export const SelectCountries = ({
  value,
  onBlur,
  errors,
  onChange,
  touched,
  disabled
}: ISelectCountriesProps): ReactElement => {
  const intl = useIntl()
  const { data } = useCountries()
  const countries = data?.countries?.items || []

  return (
    <Select
      id="countryCode"
      value={value}
      onChange={({ target: { value } }: ChangeEvent<HTMLSelectElement>): void => {
        onChange(value)
      }}
      onBlur={onBlur}
      touched={touched}
      errors={errors}
      label={<FormattedMessage id="dictionary.countryCode" defaultMessage="Country" />}
      disabled={disabled}
    >
      <option value="">{intl.formatMessage(messages.selectCountryCode)}</option>
      {countries.map((country): ReactElement => {
        return (
          <option key={country.code} value={country.code}>
            {`${country.name} - ${country.code}`}
          </option>
        )
      })}
    </Select>
  )
}
